import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';
import Edit from "../Edit";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import communityApi from "src/api/communityApi";

import { uploadImage } from "src/actions/community/imagesActions";
import ListGrid from "./_ListGrid";
import ListTable from "./_ListTable";
import { ImageInterface } from "../../../../store/community/imagesSlice";
import usePermissions from "src/hooks/usePermissions";

interface propsInterface {
  limit: number;
  targetId?: EntityId | number;
  targetType: ImageInterface['target_type'];
  type?: 'list' | 'grid';
}

const _List = (
  {
    limit,
    targetId,
    targetType,
    type = 'grid'
  }: propsInterface
) => {
  const dispatch  = useAppDispatch();
  const count     = useAppSelector(state => state.community.images.count);
  const error     = useAppSelector(state => state.community.images.error);
  const status    = useAppSelector(state => state.community.images.status);
  const { write_community } = usePermissions();
  const targetKey : string = `${targetType.toLowerCase()}_id`;

  function handleUploadSuccess(response: any) {
    dispatch(uploadImage(response));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {
        write_community && targetId &&
          <GroupUpload
            className='v-mb-10'
            name='file'
            action={communityApi.oneSky.url('/onesky/images')}
            headers={communityApi.oneSky.uploadHeaders}
            data={{ [targetKey]: targetId }}
            onSuccess={handleUploadSuccess}
          />
      }

      { type === 'grid' && <ListGrid /> }
      { type === 'list' && <ListTable className='v-mb-15' /> }

      {<Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
